import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PARTICIPANT_DELETE_REQUEST = 'DELETE_PARTICIPANT_REQUEST';
export const PARTICIPANT_DELETE_FAILURE = 'DELETE_PARTICIPANT_FAILURE';
export const PARTICIPANT_DELETE_SUCCESS = 'DELETE_PARTICIPANT_SUCCESS';

/** The backend's answers when the entry's category already has a draw (4 Oct 2026). */
export const DRAW_EXISTS = 'errors.participant.drawExists';
export const DRAW_EXISTS_CONFIRM = 'errors.participant.drawExistsConfirm';

/**
 * Remove an entry. Resolves with what happened:
 *   'deleted'      — removed (and, with `cancelDraw`, its category's draw cancelled);
 *   'confirmDraw'  — the category has a draw and the caller may cancel it:
 *                    ask, then call again with `{ cancelDraw: true }`;
 *   'failed'       — refused or broken; the error is already on screen
 *                    (a trainer's «drawn category» refusal included).
 *
 * `competition` (an id) lets the category list re-read: removing an entry
 * changes its counts, and cancelling a draw its every mark.
 */
export const deleteParticipant = (id, { cancelDraw = false, competition = null } = {}) => {
    const params = [];
    params['id'] = id;
    return function(dispatch) {
        dispatch(deleteRequest());
        return axios({
            ...apiRequestOptions(apiPath.PARTICIPANT.DELETE, null, {params}),
            ...(cancelDraw ? { params: { cancelDraw: 1 } } : {}),
        })
            .then(transformHttpResponse)
            .then(() => {
                dispatch(deleteSuccess(id, competition));
                dispatch(addSuccessMessage('Participant successfully deleted'));

                return 'deleted';
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteFailure(error));
                if (409 === error.status && JSON.stringify(error.data || {}).includes(DRAW_EXISTS_CONFIRM)) {
                    return 'confirmDraw';
                }
                dispatch(errorRequestHandler(error));

                return 'failed';
            });
    }
};

const deleteRequest = () => {
    return {
        type: PARTICIPANT_DELETE_REQUEST,
    }
};

const deleteFailure = (error) => {
    return {
        type: PARTICIPANT_DELETE_FAILURE,
        error,
    }
};

const deleteSuccess = (participant, competition) => {
    return {
        type: PARTICIPANT_DELETE_SUCCESS,
        participant,
        competition,
    }
};